export default [
  {
    path: 'checklist-content/:checklistId/record-list',
    name: 'OldChecklistRecordList',
    component: () => import('@/views/Checklist/RecordList.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-checklist',
      template: 'auth',
    },
  },
  {
    path: 'checklist-content/:checklistId/create-schedule',
    name: 'createChecklistSchedule',
    component: () => import('@/views/Checklist/Schedule/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-checklist',
      template: 'auth',
    },
  },
  {
    path: 'checklist-content/:checklistId/assignment-index',
    name: 'OldChecklistAssignmentIndex',
    component: () => import('@/views/Checklist/AssignmentIndex.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-checklist',
      template: 'auth',
    },
  },
  {
    path: 'checklist-content/:checklistId/schedule/:scheduleId',
    name: 'checklistSchedule',
    component: () => import('@/views/Checklist/Schedule/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-checklist',
      template: 'auth',
    },
  },
  {
    path: 'checklist-content/:checklistId/schedule/:scheduleId/update',
    name: 'updateChecklistSchedule',
    component: () => import('@/views/Checklist/Schedule/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-checklist',
      template: 'auth',
    },
  },
  {
    path: 'checklist-assignment/:assignmentId/:checklistId',
    name: 'assignmentChecklistWithChecklistId',
    component: () => import('@/views/Checklist/Assignment.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'board-checklist-assignment',
      template: 'auth',
      has_auth: true,
    },
  },
  {
    path: 'checklist-assignment/:assignmentId',
    name: 'assignmentChecklist',
    component: () => import('@/views/Checklist/Assignment.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'board-checklist-assignment',
      template: 'auth',
      has_auth: true,
    },
  },
  {
    path: 'checklist-result/:recordId',
    name: 'resultChecklist',
    component: () => import('@/views/Checklist/Result.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'board-checklist-review',
      template: 'auth',
      has_auth: true,
    },
  },
  {
    path: 'checklist-common-choice-group-update/:id',
    name: 'OldChecklistCommonChoiceGroupUpdate',
    component: () => import('@/views/Checklist/CommonChoiceGroup/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-checklist',
      template: 'auth',
    },
  },
  {
    path: 'printing/checklist-result',
    name: 'PrintingChecklistResult',
    component: () => import('@/views/Printing/ChecklistResult.vue'),
    props: true,
    meta: {
      name: 'printing-task',

      middleware: 'auth',
      template: 'printing',
    },
  },
  {
    path: 'checklists',
    name: 'checklists',
    component: () => import('@/views/Checklist/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-checklist',
      template: 'auth',
      has_auth: true,
    },
  },
  {
    path: 'checklist-create',
    name: 'checklistCreate',
    component: () => import('@/views/Checklist/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-checklist',
      template: 'auth',
    },
  },
  {
    path: 'checklist-update-basic/:checklistId',
    name: 'checklistUpdate',
    component: () => import('@/views/Checklist/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-checklist',
      template: 'auth',
    },
  },
  {
    path: 'checklist-content/:checklistId',
    name: 'checklistContent',
    component: () => import('@/views/Checklist/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-checklist',
      template: 'auth',
    },
  },
  {
    path: 'checklist/:checklistId/checklist-record-list',
    name: 'checklistRecordList',
    component: () => import('@/views/Checklist/RecordList.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-checklist',
      template: 'auth',
    },
  },
  {
    path: 'checklist/:checklistId/checklist-schedule-create',
    name: 'checklistScheduleCreate',
    component: () => import('@/views/Checklist/Schedule/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-checklist',
      template: 'auth',
    },
  },
  {
    path: 'checklist/:checklistId/checklist-assignment-index',
    name: 'checklistAssignmentIndex',
    component: () => import('@/views/Checklist/AssignmentIndex.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-checklist',
      template: 'auth',
    },
  },
  {
    path: 'checklist/:checklistId/checklist-schedule-content/:scheduleId',
    name: 'checklistScheduleContent',
    component: () => import('@/views/Checklist/Schedule/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-checklist',
      template: 'auth',
    },
  },
  {
    path: 'checklist/:checklistId/checklist-schedule-update/:scheduleId',
    name: 'checklistScheduleUpdate',
    component: () => import('@/views/Checklist/Schedule/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-checklist',
      template: 'auth',
    },
  },
  {
    path: 'checklist-template-content/:templateId',
    name: 'checklistTemplateContent',
    component: () => import('@/views/Checklist/ShowTemplate.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-checklist',
      template: 'auth',
    },
  },
  {
    path: 'checklist-assignment-temporary/:checklistId/:recordId?',
    name: 'checklistAssignmentTemporary',
    component: () => import('@/views/Checklist/Assignment.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'board-checklist-assignment',
      template: 'auth',
      has_auth: true,
    },
  },
  {
    path: 'checklist-assignment-main/:assignmentId',
    name: 'checklistAssignment',
    component: () => import('@/views/Checklist/Assignment.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'board-checklist-assignment',
      template: 'auth',
      has_auth: true,
    },
  },
  {
    path: 'checklist-result-view/:recordId',
    name: 'checklistResult',
    component: () => import('@/views/Checklist/Result.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'board-checklist-review',
      template: 'auth',
      has_auth: true,
    },
  },
  {
    path: 'checklist-common-choice-group-create',
    name: 'checklistCommonChoiceGroupCreate',
    component: () => import('@/views/Checklist/CommonChoiceGroup/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-checklist',
      template: 'auth',
    },
  },
  {
    path: 'checklist-common-choice-group-content/:id',
    name: 'checklistCommonChoiceGroupContent',
    component: () => import('@/views/Checklist/CommonChoiceGroup/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-checklist',
      template: 'auth',
    },
  },
  {
    path: 'checklist-common-choice-group-update/:id',
    name: 'checklistCommonChoiceGroupUpdate',
    component: () => import('@/views/Checklist/CommonChoiceGroup/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-checklist',
      template: 'auth',
    },
  },
  {
    path: 'print-checklist-result',
    name: 'printChecklistResult',
    component: () => import('@/views/Printing/ChecklistResult.vue'),
    props: true,
    meta: {
      name: 'printChecklistResult',
      middleware: 'auth',
      template: 'printing',
    },
  },
];
